export interface NavItem {
  path: string
  icon: string
  titleId: string
}

export const navItems: NavItem[] = [
  {
    path: '/',
    icon: 'home-filled',
    titleId: 'nav.home'
  }
]
